import React from 'react';
import OrdersPage from "pages/orders/containers/OrdersPage";

function Index() {
    return <OrdersPage />;
}

export default Index;